export const socketEn = {
    connection: {
        disconnected: 'Connection lost. Please refresh the page.'
    }
}
